module.exports = __webpack_public_path__ + "static/media/clientsmechiron.7540acb0.svg";